import { render, staticRenderFns } from "./Agendas.vue?vue&type=template&id=2ed8ba00"
import script from "./Agendas.vue?vue&type=script&lang=ts"
export * from "./Agendas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports